import { inject } from 'mobx-react'
import React from 'react'
import { Icon } from 'ui-framework'

type Theme = 'light' | 'dark'

function applyTheme(theme: Theme) {
  document.documentElement.setAttribute('data-theme', theme)
  localStorage.setItem('theme', theme)
}

export function ThemeSwitch(props: any) {
  const { rootStore } = props

  const [theme, setTheme] = React.useState<Theme>(
    (localStorage.getItem('theme') || 'dark') as Theme
  )

  React.useEffect(() => {
    applyTheme(theme)
    rootStore.uiStore.set('theme', theme)
  }, [theme])

  function onChange() {
    setTheme(theme === 'dark' ? 'light' : 'dark')
  }

  return (
    <div className="btn-menu-square" onClick={onChange}>
      <Icon
        name={theme === 'light' ? 'Light' : 'Dark'}
        width={33}
        height={25}
        color="var(--color-txt-muted)"
      />
    </div>
  )
}

export default inject('rootStore')(ThemeSwitch)
